// Images
import react from "../img/logos/react.png";
import redux from "../img/logos/redux.png";
import next from "../img/logos/next.png";
import graphql from "../img/logos/graphql.png";
import javascript from "../img/logos/javascript.png";
import html from "../img/logos/html.png";
import css from "../img/logos/css.png";
import sass from "../img/logos/sass.png";
import node from "../img/logos/node.png";
import express from "../img/logos/express.png";
import mongo from "../img/logos/mongo.png";
import git from "../img/logos/git.png";
import github from "../img/logos/GitHub.png";
import axios from "../img/logos/axios.png";
import query from "../img/logos/query.png";
import adobe from "../img/logos/adobe.png";
import photoshop from "../img/logos/photoshop.png";
import premiere from "../img/logos/premiere.jpg";
import lightroom from "../img/logos/lightroom.png";

export const SkillData = [
  {
    image: react,
    text: "ReactJS",
  },
  {
    image: javascript,
    text: "JavaScript",
  },
  {
    image: html,
    text: "HTML5",
  },
  {
    image: css,
    text: "CSS3",
  },
  // {
  //   image: redux,
  //   text: "Redux",
  // },
  {
    image: next,
    text: "Next",
  },
  // {
  //   image: graphql,
  //   text: "Graphql",
  // },
  {
    image: sass,
    text: "SASS",
  },
  {
    image: node,
    text: "NodeJS",
  },
  {
    image: express,
    text: "ExpressJS",
  },
  {
    image: mongo,
    text: "MongoDB",
  },
  {
    image: git,
    text: "Git",
  },
  {
    image: github,
    text: "GitHub",
  },
  {
    image: axios,
    text: "Axios",
  },
  {
    image: query,
    text: "JQuery",
  },
  {
    image: adobe,
    text: "Adobe",
  },
  {
    image: photoshop,
    text: "Photshop",
  },
  {
    image: premiere,
    text: "Premiere",
  },
  {
    image: lightroom,
    text: "Lightroom",
  },
];
